import { Popover, styled } from "@mui/material";

const DialogMenu = styled(Popover)(() => ({
  "& .MuiBackdrop-root": {
    background: "#030712",
    opacity: "0.3 !important",
  },
  "& .MuiPaper-root": {
    width: 400,
    marginTop: 12,
    border: "1px solid #DCDCDE",
    borderRadius: 12,
    boxShadow: "0px 10px 10px 0 #100A551A",
  },
  "& .MuiList-root": {
    padding: "0",
  },
}));

export default DialogMenu;
